import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const closingNotes_routes = [
  {
    path: 'closingNotes',
    name: 'closingNotes',
    meta: {
      permissions: 'read-closing-notes',
      breadcrumbs: settingsBreadcrumbs({
        label: 'global.sidebar.closing_trans',
        route: { name: 's-closing-notes' },
      }),
    },
    children: [
      {
        path: '',
        name: 's-closing-notes',
        component: () => import('@/views/System/Settings/ClosingNotes/ClosingNotesList.vue'),
        meta: {
          permissions: 'read-closing-notes',
        },
      },
    ],
  },
];

export default closingNotes_routes;
